import { z } from 'zod';

export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;

export const supportStaffSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'supportStaff.form.errors.nameRequired')
    .max(120, 'supportStaff.form.errors.tooLong'),
  contact_link: z
    .string()
    .trim()
    .min(1, 'supportStaff.form.errors.contactRequired')
    .url('supportStaff.form.errors.contactInvalid'),
  languages: z
    .array(z.string().trim().min(1))
    .min(1, 'supportStaff.form.errors.languagesRequired'),
  // Modelled as a string so the number input can be empty; validated as an
  // optional non-negative integer and converted on submit.
  experience_years: z
    .string()
    .trim()
    .refine((v) => v === '' || /^\d+$/.test(v), 'supportStaff.form.errors.experienceMin'),
  image: z
    .instanceof(File)
    .refine((f) => f.type.startsWith('image/'), 'supportStaff.form.errors.imageType')
    .refine((f) => f.size <= MAX_IMAGE_BYTES, 'supportStaff.form.errors.imageTooLarge')
    .optional(),
});

export type SupportStaffFormValues = z.infer<typeof supportStaffSchema>;

export const emptySupportStaffFormValues: SupportStaffFormValues = {
  name: '',
  contact_link: '',
  languages: [],
  experience_years: '',
  image: undefined,
};
